<template>
  <div class="bg-white mar-top">
    <back-route-hdr :back-mode="'func'" :cur-hash="'periodic'"
                    @handle-back="handleBack(true)"></back-route-hdr>
    <van-cell-group class="mar-operate-btm">
      <van-cell title="添加会议时间" is-link @click="handleSheet()"></van-cell>
      <van-cell v-for="(ele, idx) in formattedSelection" :key="ele.startTime" center>
        <template #title>
          <span>{{idx + 1}}. {{ele.dateTime}} {{ele.weekDay}} {{ele.meetingTime}}</span>
        </template>
        <template #right-icon>
          <i class="fa fa-pencil text-lg mar-rgt" @click="handleSheet(ele, idx)"></i>
          <van-icon name="clear" class="text-lg" @click="removeDoc(ele, idx)"></van-icon>
        </template>
      </van-cell>
    </van-cell-group>

    <div class="fixed-btm-box bord-top">
      <div class="pull-right pad-all-10">
        <van-button icon="arrow-left" size="small" class="mar-rgt" @click="handleBack(true)">返回</van-button>
        <van-button type="primary" size="small" @click="handleBack()">确定修改</van-button>
      </div>
    </div>

    <van-action-sheet v-model="showSheet" :title="(forAdd?`添加`:`修改`)+'会议时间'" :overlay="false">
      <van-form label-align="right" label-width="80" @submit="onSubmit">
        <van-cell is-link @click="handleDatePicker('start')">
          <template #title>
            <span class="text-danger">*</span> <span>开始时间</span>
          </template>
          <template #right-icon>
            <span>{{timeCN.start || "请选择"}}</span>
            <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
          </template>
        </van-cell>
        <van-cell is-link @click="handleDatePicker('end')">
          <template #title>
            <span class="text-danger">*</span> <span>结束时间</span>
          </template>
          <template #right-icon>
            <span>{{timeCN.end || "请选择"}}</span>
            <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
          </template>
        </van-cell>
        <div class="mar-all">
          <van-button type="primary" block size="small" @click="">暂存</van-button>
        </div>
      </van-form>
    </van-action-sheet>

    <!-- 选择完整时间 -->
    <van-popup v-model="showDatePicker" position="bottom">
      <div style="position: relative">
        <van-datetime-picker type="datetime" :key="datePickerFor"
                             :title="datePickerData.title"
                             :value="datePickerData.value"
                             :min-date="datePickerData.minDate"
                             :max-date="datePickerData.maxDate"
                             :filter="dateFilter" :formatter="dateFormatter"
                             @change="changeStartDate"
                             @confirm="confirmDate" @cancel="showDatePicker = false">
        </van-datetime-picker>
        <!--<div class="week-value">{{weekValue}}</div>-->
      </div>
    </van-popup>


  </div>
</template>

<script>
  import {frontConfirm, getDefaultTime} from "../../../../../tools/utils";
  import {commonConfig, momentFormat} from "../../../../../config/common";

  const weeks = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
  export default {
    props: {
      curData: Array,
      minDate: Date,
      maxDate: Date,
      mtTime: Object
    },
    data() {
      return {
        selection: [],
        sheetDoc: {},
        showSheet: false,
        forAdd: true,

        curHour: (new Date()).getHours(),
        weekValue: weeks[new Date().getDay()],
        showDatePicker: false,
        datePickerFor: "",
      }
    },
    computed: {
      formattedSelection() {
        return this.selection.map(e => {
          const {startTime, endTime} = e;
          return {
            ...e,
            dateTime: moment(startTime).format(momentFormat.dateFormatDayCN),
            weekDay: "周" + commonConfig.weekInfo[new Date(startTime).getDay()],
            meetingTime: `${moment(startTime).format(momentFormat.time)}-${moment(endTime).format(momentFormat.time)}`,
          }
        })
      },
      timeCN() {
        return {
          start: this.sheetDoc.startTime && moment(this.sheetDoc.startTime).format(momentFormat.dateFormatDetailCN),
          end: this.sheetDoc.endTime && moment(this.sheetDoc.endTime).format(momentFormat.dateFormatDetailCN),
        }
      },
      unitMinutes() {
        return this.$store.state.sysConfig.unitMinutes || 10
      },
      // 单场会议时长限制
      meetingDurationLimit() {
        const meetingDurationLimit = this.$store.state.sysConfig.meetingDurationLimit || 0;
        if (meetingDurationLimit && meetingDurationLimit < this.unitMinutes) {
          return this.unitMinutes
        }
        return meetingDurationLimit
      },
      datePickerData() {
        switch (this.datePickerFor) {
          case 'start':
            return {
              title: "开始时间",
              minDate: this.minDate,
              maxDate: this.maxDate,
              value: this.sheetDoc.startTime,
            };
          case 'end':
            return {
              title: "结束时间",
              minDate: moment(this.sheetDoc.startTime).add(this.unitMinutes, 'm').toDate(),
              maxDate: this.meetingDurationLimit
                ? moment(this.sheetDoc.startTime).add(this.meetingDurationLimit, 'm').toDate() : this.maxDate,
              value: this.sheetDoc.endTime,
            };
          default:
            return {}
        }
      },
    },
    watch: {
      "sheetDoc.startTime": function (val, oldVal) {
        if (val) {
          const duration = oldVal && moment(this.sheetDoc.endTime).diff(moment(oldVal), 'm') || 60;
          this.sheetDoc.endTime = moment(val).add(duration, 'm').toDate()
        }
      },
    },
    created() {
      this.selection = [...this.curData || []]
    },
    methods: {
      handleSheet(ele, idx) {
        if (ele) {
          this.sheetDoc = {
            startTime: new Date(ele.startTime),
            endTime: new Date(ele.endTime),
            cnt: idx + 1
          };
          this.forAdd = false
        } else {
          this.sheetDoc = {};
          this.forAdd = true
        }
        this.showSheet = true
      },
      removeDoc(ele, idx) {
        frontConfirm({msg: `是否确认删除会议时间【${ele.dateTime} ${ele.meetingTime}】？`}, () => {
          this.selection.splice(idx, 1);
        })
      },
      onSubmit() {
        if (!this.sheetDoc.startTime || !this.sheetDoc.endTime) {
          vtToast(`请选择时间`);
          return
        }
        const cIdx = this.sheetDoc.cnt && (this.sheetDoc.cnt - 1);
        const info = {
          startTime: this.sheetDoc.startTime.valueOf(),
          endTime: this.sheetDoc.endTime.valueOf(),
        };
        const checkCross = this.selection.concat(this.mtTime).some((e, i) => {
          if (i === cIdx) return false;
          if (info.startTime === e.startTime || info.endTime === e.endTime) return true;
          // 时间交叉
          if (info.startTime > e.startTime && info.startTime < e.endTime) return true;
          if (info.startTime < e.startTime && info.endTime > e.startTime) return true;
        });
        if (checkCross) {
          vtToast(`会议时间重复`);
          return
        }
        if (this.sheetDoc.cnt) {
          this.selection[cIdx] = info;
          this.selection = [].concat(this.selection)
        } else {
          this.selection.push(info)
        }
        this.showSheet = false;
        this.sheetDoc = {};
      },
      handleBack(rtn) {
        if (rtn && JSON.stringify(this.curData) !== JSON.stringify(this.selection)) {
          frontConfirm({msg: "是否丢弃当前更改？"}, () => {
            this.$emit('change-info', null)
          });
          return
        }
        this.$emit('change-info', rtn ? null : this.selection)
      },

      handleDatePicker(type) {
        this.datePickerFor = type;
        this.showDatePicker = true;
      },
      dateFilter(type, options) {
        if (type === 'minute') {
          return options.filter((option) => option % this.unitMinutes === 0)
        }
        return options;
      },
      dateFormatter(type, val) {
        switch (type) {
          case 'year':
            return `${val}年`;
          case 'month':
            return `${val}月`;
          case 'day':
            return `${val}日`;
          default:
            return val;
        }
      },
      changeStartDate(evt) {
        this.curHour = evt.getColumnValue(3);

        // 计算当前选择日期是周几
        const dataStr = evt.getValues().slice(0, 3).reduce((result, item) => {
          return result ? result + '-' + parseInt(item) : parseInt(item);
        }, '');
        this.weekValue = weeks[new Date(dataStr).getDay()];
      },
      confirmDate(date) {
        // console.log(date)
        switch (this.datePickerFor) {
          case 'start':
            this.sheetDoc = {...this.sheetDoc, startTime: date};
            break;
          case 'end':
            this.sheetDoc = {...this.sheetDoc, endTime: date};
            break;
          default:
        }
        this.showDatePicker = false;
        this.datePickerFor = "";
      },
    }
  }
</script>

<style scoped>
</style>
